import { render } from "./fsbm.vue?vue&type=template&id=3e4b7cd0&scoped=true"
import script from "./fsbm.vue?vue&type=script&lang=js"
export * from "./fsbm.vue?vue&type=script&lang=js"

import "../assets/fs/newForm.css?vue&type=style&index=0&id=3e4b7cd0&scoped=true&lang=css&external"
import "./fsbm.vue?vue&type=style&index=1&id=3e4b7cd0&scoped=true&lang=css"
import "./fsbm.vue?vue&type=style&index=2&id=3e4b7cd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4b7cd0"]])

export default __exports__